import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContextFactory } from '@streem/toolbox';
import { useCallback, useMemo, useState } from 'react';
import { detectExceededCharacterLimit, detectIsSendNoteDisabled } from '../../util/notes';
const [InternalEditorStateContextProvider, useEditorStateContext,] = createContextFactory('EditorStateContext');
export { useEditorStateContext };
export function EditorStateContextProvider({ children, markdownPersistedToBackend, defaultTemplate, onSave, onNoteUpdated, maxCharacters, sendNote, noteFinalizedYn, captureButtonClick, inCallOrPostCall, initialMarkdown, sendNoteEnabledYn, readOnlyYn = false, }) {
    const [currentMarkdownInEditor, setCurrentMarkdownInEditor] = useState(initialMarkdown);
    // initialize displayModeYn to true when data has been persisted and the persisted data is the same as initialMarkdown
    const [displayModeYn, setDisplayModeYn] = useState(!!markdownPersistedToBackend && markdownPersistedToBackend === initialMarkdown);
    const handleSave = useCallback(async () => {
        await onSave(currentMarkdownInEditor);
        setDisplayModeYn(true);
    }, [currentMarkdownInEditor, onSave]);
    const handleSendNote = useCallback(async () => {
        if (!readOnlyYn) {
            await handleSave();
        }
        await sendNote(currentMarkdownInEditor);
    }, [currentMarkdownInEditor, handleSave, readOnlyYn, sendNote]);
    const handleMarkdownUpdated = useCallback((markdown) => {
        setCurrentMarkdownInEditor(markdown);
        onNoteUpdated?.(markdown);
    }, [onNoteUpdated]);
    const editorStateContext = useMemo(() => {
        const exceededCharacterLimit = detectExceededCharacterLimit(currentMarkdownInEditor, maxCharacters);
        const isSendNoteDisabledYn = detectIsSendNoteDisabled(currentMarkdownInEditor, readOnlyYn, exceededCharacterLimit);
        return {
            persistedToBackend: markdownPersistedToBackend,
            defaultTemplate,
            currentMarkdownInEditor,
            handleMarkdownUpdated,
            onSave: handleSave,
            sendNote: handleSendNote,
            displayModeYn,
            setDisplayModeYn,
            maxCharacters,
            exceededCharacterLimit,
            noteFinalizedYn,
            captureButtonClick,
            inCallOrPostCall,
            readOnlyYn,
            isSendNoteDisabledYn,
            sendNoteEnabledYn,
        };
    }, [
        currentMarkdownInEditor,
        defaultTemplate,
        handleMarkdownUpdated,
        handleSave,
        handleSendNote,
        markdownPersistedToBackend,
        displayModeYn,
        maxCharacters,
        noteFinalizedYn,
        captureButtonClick,
        inCallOrPostCall,
        readOnlyYn,
        sendNoteEnabledYn,
    ]);
    return (_jsx(InternalEditorStateContextProvider, { value: editorStateContext, children: children }));
}
//# sourceMappingURL=notes_editor_state_context.js.map